import { useCallback, useState } from 'react';

// Words past this many aren't remembered, the first added going first.
const MAX_WORDS = 1000;

function readWords(key: string): ReadonlySet<string> {
  try {
    const stored: unknown = JSON.parse(localStorage.getItem(key) ?? '[]');
    return new Set(Array.isArray(stored) ? stored.filter((word) => typeof word === 'string') : []);
  } catch {
    // Storage can be unavailable, as in private windows, or hold something else.
    return new Set();
  }
}

/** Words added one at a time, remembered in this browser. */
export function useStoredWords(key: string): [ReadonlySet<string>, (word: string) => void] {
  const [words, setWords] = useState(() => readWords(key));

  const add = useCallback(
    (word: string) => {
      const next = new Set([...words, word].slice(-MAX_WORDS));
      setWords(next);
      try {
        localStorage.setItem(key, JSON.stringify([...next]));
      } catch {
        // Remembering is a convenience; the word still counts in this session.
      }
    },
    [key, words],
  );

  return [words, add];
}
